export default __webpack_public_path__ + "static/volkswagen-t-cross~bladTsro-97b640c975aee77d9acde81c9a5e6bc5.jpg";